//#region src/currency/to-currencies.ts
var e = (e) => Number(e), t = (e) => Number(e), n = (e) => e / 100, r = (e) => Number(e) * 100;
//#endregion
export { e as cents, n as centsToUnits, t as units, r as unitsToCents };
